import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class PageListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let self = this;
        let vm = this.props.vm; 
        let isSystemPage = this.props.noLabel;
        let pageNameUrl = context.root() + '/app/add-page/' + vm.id;

        if (vm.canDelete) {
            isSystemPage = this.props.yesLabel;
        }

        return (
            <tr>
                <td>
                    <a href={pageNameUrl}>{vm.id}</a>
                </td>
                <td>
                    <a href={pageNameUrl}>{vm.pageName}</a>
                </td>
                <td>{isSystemPage}</td>
                <td>{vm.formattedCreationDate}</td>
                <td>{vm.creationOperator}</td>
                <td>{vm.formattedModifyDate}</td>
                <td>{vm.modifyOperator}</td>
            </tr>
        );
    }
}